import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ResultType } from '../../../../../models/enums/result-type.enum';
import { ManagementApiService } from '../../../../../services';
import { CustomToastService } from '../../../../../services/custom-toast.service';

@Component({
    selector: 'app-shared-content-remove',
    templateUrl: './shared-content-remove.component.html',
    styleUrls: ['./shared-content-remove.component.scss'],
    standalone: false
})
export class SharedContentRemoveComponent {
    @Input() sharedContentId: string;
    @Input() generalTabIndex: number;
    @Output() refreshSharedContents: EventEmitter<number> = new EventEmitter();

    tooltip_position = 'above';
    closeResult: string;
    result: ResultType = ResultType.Error;

    constructor(
        private modalService: NgbModal,
        private mgmtApi: ManagementApiService,
        private customToastService: CustomToastService,
        private user_utlity: UserUtilityService,
        private globalEmittersService: GlobalEmittersService
    ) {}

    open(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                windowClass: 'my_modal_class',
                size: 'md',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    async btnDeleteSharedContent() {
        await this.removeSharedContent();
        this.modalService.dismissAll();
    }

    async removeSharedContent() {
        let res = await this.mgmtApi.removeSharedContent(this.sharedContentId).toPromise();
        if (res.success === true) {
            this.refreshSharedContents.emit(this.generalTabIndex);
            this.customToastService.successToast('Successfully deleted!');
            this.globalEmittersService.refreshContentGeneralSetting.next(true);
        } else {
            this.user_utlity.errorModelPopup(res.message);
        }
    }
}
